class HeaderTransparent extends HTMLElement {
  constructor() {
    super();

    // select element
    this.header = document.querySelector('[data-header]');
    this.headerWrapper = document.querySelector('#shopify-section-header');
    this.announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.headerElement = this;

    if (this.headerWrapper) {
      // scroll parameters
      this.currentScrollTop = 0;
      this.scrollOffset = 0;
      this.headerStart = 0;

      if (this.announcementBar) {
        const announcementBarHeight = this.announcementBar.offsetHeight;
        this.scrollOffset += announcementBarHeight;
        this.headerStart += announcementBarHeight;
      }

      if (this.headerElement) {
        this.scrollOffset += this.headerElement.offsetHeight;
      }

      // scroll event
      this.raf = null; // Safe request animation frame
      this.timer = null, // Safe scroll timer
      this.scrollListener();
      window.addEventListener('scroll', () => {
        this.scrollListener();
      }, false);

    }
  }

  scrollListener() {
    clearTimeout(this.timer);
    if (!this.raf) {
      // A request animation frame is used to animate on max 60fps.
      this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
    }
    this.timer = setTimeout(() => {
      // Stop animation, cancel request animation frame
      cancelAnimationFrame(this.raf);
      this.raf = null;
    }, 50);
  }

  scrollAnimation() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // only animate if header is closed.
    if (!this.header?.classList?.contains('header--is-open')) {

      if (scrollTop <= this.headerStart) {
        this.handleHeaderTransparency(true);
      } else {
        this.handleHeaderTransparency(false);
      }
    }

    this.currentScrollTop = scrollTop;

    // Recall request animation loop
    this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
  }

  handleHeaderTransparency(isTransparent) {
    if (isTransparent) {
      this.headerElement.classList.add('header--transparent');
    } else {
      this.headerElement.classList.remove('header--transparent');
    }
  }
}

if (!customElements.get('header-transparent')) {
  customElements.define('header-transparent', HeaderTransparent);
}
